import { render, staticRenderFns } from "./tabMasterUICustomLayout.vue?vue&type=template&id=393d478f&"
import script from "./tabMasterUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabMasterUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('393d478f')) {
      api.createRecord('393d478f', component.options)
    } else {
      api.reload('393d478f', component.options)
    }
    module.hot.accept("./tabMasterUICustomLayout.vue?vue&type=template&id=393d478f&", function () {
      api.rerender('393d478f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMasterUICustomLayout.vue"
export default component.exports